import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import BottomDrawer from '../../Drawer/Drawer';
import SfhSecondaryButton from './SfhSecondaryButton';

const DrawerWrapper = styled.div`
  h2 {
    font-family: ${variables.family.goldSilver}, sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
    color: ${themeColors.colorTextPrimary};
  }
`;

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 8px 0;
`;

const Section = styled.p`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${themeColors.colorTextSecondary};
  margin: 0;

  > strong {
    font-weight: 700;
    color: ${themeColors.colorTextSecondary};
  }
`;

const Footnote = styled.p`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${themeColors.colorTextSecondary};
  margin: 8px 0 0;
`;

const DrawerFooter = styled.div`
  > button {
    width: 100%;
    color: ${themeColors.colorPrimary};
    font-weight: 600;
  }
`;

const SellFromHomePreAuthDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const footer = (
    <DrawerFooter>
      <SfhSecondaryButton onClick={onClose} data-cy="button-sfh-preauth-got-it">
        {t('sellWizard.sfhWizard.preAuthDrawer.gotIt')}
      </SfhSecondaryButton>
    </DrawerFooter>
  );

  return (
    <DrawerWrapper>
      <BottomDrawer
        isOpen={isOpen}
        onClose={onClose}
        title={t('sellWizard.sfhWizard.preAuthDrawer.title')}
        footer={footer}
        maxHeight="70%"
      >
        <Sections>
          <Section>
            <strong>
              {t('sellWizard.sfhWizard.preAuthDrawer.priceGuaranteeLabel')}
            </strong>{' '}
            {t('sellWizard.sfhWizard.preAuthDrawer.priceGuaranteeBody')}
          </Section>
          <Section>
            <strong>
              {t('sellWizard.sfhWizard.preAuthDrawer.preAuthLabel')}
            </strong>{' '}
            {t('sellWizard.sfhWizard.preAuthDrawer.preAuthBody')}
          </Section>
          <Footnote>
            {t('sellWizard.sfhWizard.preAuthDrawer.footnote')}
          </Footnote>
        </Sections>
      </BottomDrawer>
    </DrawerWrapper>
  );
};

SellFromHomePreAuthDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SellFromHomePreAuthDrawer;
